import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../api';
import { IUser } from '../userApi/interface';
import { ISignUp, ILoginWithEmail, IIdentifierPayload, IVerifyUserPayload, IVerifyResetPasswordToken, IResetPassword } from './interface';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    registerUser: builder.mutation<IUser, ISignUp>({
      query: (body) => ({
        url: '/auth/register',
        method: 'POST',
        body,
      }),
    }),
    verifyUser: builder.mutation<{ message: string }, IVerifyUserPayload>({
      query: (body) => ({
        url: '/auth/verify-user',
        method: 'POST',
        body,
      }),
    }),
    resendVerification: builder.mutation<string, IIdentifierPayload>({
      query: (body) => ({
        url: '/auth/resend-verification',
        method: 'POST',
        body,
      }),
    }),
    loginWithEmail: builder.mutation<{ access_token: string; refresh_token: string; token_type: string }, ILoginWithEmail>({
      query: (body) => ({
        url: '/auth/login/email',
        method: 'POST',
        body,
      }),
    }),
    // refreshToken: builder.mutation<{ access_token: string; token_type: string }, ''>({
    //   query: (body) => ({
    //     url: '/auth/refresh-token',
    //     method: 'POST',
    //     body,
    //   }),
    // }),
    initializeResetPassword: builder.mutation<'', IIdentifierPayload>({
      query: (body) => ({
        url: '/auth/password/forgot',
        method: 'POST',
        body,
      }),
    }),
    verifyResetPasswordToken: builder.mutation<'', IVerifyResetPasswordToken>({
      query: (body) => ({
        url: '/auth/password/reset/verify',
        method: 'POST',
        body,
      }),
    }),
    resetPassword: builder.mutation<'', IResetPassword>({
      query: (body) => ({
        url: '/auth/password/reset',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useRegisterUserMutation,
  useVerifyUserMutation,
  useResendVerificationMutation,
  useLoginWithEmailMutation,
  useInitializeResetPasswordMutation,
  useVerifyResetPasswordTokenMutation,
  useResetPasswordMutation,
} = authApi;
